import { render, staticRenderFns } from "./corpCertApplySuccess.vue?vue&type=template&id=39f1c218&scoped=true"
import script from "./corpCertApplySuccess.vue?vue&type=script&lang=js"
export * from "./corpCertApplySuccess.vue?vue&type=script&lang=js"
import style0 from "./corpCertApplySuccess.vue?vue&type=style&index=0&id=39f1c218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1c218",
  null
  
)

export default component.exports